// D-33: Engineering constant - keep in sync with backend CURRENT_CONSENT_VERSION
// in src/lambda/user_profile_service_v3.py. Plan 11 (Wave 4) bumps this to '2.0'
// AFTER the web team publishes the new Privacy Policy and T&C at
// afterservice.ai/privacy/ and afterservice.ai/terms/. Bumping this value
// triggers the re-acceptance prompt for all existing users on next login.
export const CURRENT_CONSENT_VERSION = '2.2';
